import { Route } from "react-router-dom";
import { LayoutTemplateV2 } from "../components/Templates/LayoutTemplateV2";
import { HomeV2 } from "../components/Pages/HomeV2";
import { ProtectedClientRoute } from "../components/Atoms/ProtectedClientRoute";
import { BatchDelivery } from "../components/Pages/BatchDelivery";
import { StoreV2 } from "../components/Pages/StoreV2";
import { ItineranteV2 } from "../components/Pages/ItineranteV2";

export const useAgendamentoLoteRoutes = () => {
  return (
    <Route path="/agendamento-lote" element={<LayoutTemplateV2 />}>
      <Route index element={<HomeV2 />} />
      <Route
        path="delivery"
        element={
          <ProtectedClientRoute>
            <BatchDelivery />
          </ProtectedClientRoute>
        }
      />
      <Route
        path="loja"
        element={
          <ProtectedClientRoute>
            <StoreV2 />
          </ProtectedClientRoute>
        }
      />
      <Route
        path="itinerantes"
        element={
          <ProtectedClientRoute>
            <ItineranteV2 />
          </ProtectedClientRoute>
        }
      />
    </Route>
  );
};
